import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

type Fact = { val: string; label: string; sub: string };

export function Stats() {
  const { t } = useTranslation();
  const items = t("stats.items", { returnObjects: true }) as Fact[];

  return (
    <section className="bg-white py-16 border-y border-foreground/[0.08] overflow-hidden">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-foreground/[0.08]">
          {items.map((item, i) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="px-4 text-center lg:px-6"
            >
              <div className="mb-2 font-raleway text-[34px] font-bold leading-none tracking-tight text-primary sm:text-[42px]">
                {item.val}
              </div>
              <div className="text-[14px] font-semibold text-foreground">{item.label}</div>
              <div className="mt-0.5 text-[13px] text-foreground/45">{item.sub}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
